<div style="text-align: center">
  <img src="/system/files/images/2024-06/tracmyair_logo.png" style="width: 300px" alt="TracMyAir logo">
</div>

<ul class="usa-card-group">
  <li class="usa-card grid-col-6">
    <div class="usa-card__container">
      <div class="usa-card__header">
        <h2 class="usa-card__heading">About Me</h2>
      </div>
      <div class="usa-card__body">
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use href="/themes/epa_theme/images/sprite.svg#person"></use>
        </svg>
      </div>
      <div class="usa-card__footer">
        <a class="usa-button" routerLink="/about-me" skipLocationChange>Edit My Info</a>
      </div>
    </div>
  </li>
  <li class="usa-card grid-col-6">
    <div class="usa-card__container">
      <div class="usa-card__header">
        <h2 class="usa-card__heading">About My Home</h2>
      </div>
      <div class="usa-card__body">
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use href="/themes/epa_theme/images/sprite.svg#home"></use>
        </svg>
      </div>
      <div class="usa-card__footer">
        <a class="usa-button" routerLink="/about-my-home" skipLocationChange>Edit My Home</a>
      </div>
    </div>
  </li>
  <li class="usa-card grid-col-6">
    <div class="usa-card__container">
      <div class="usa-card__header">
        <h2 class="usa-card__heading">About My Day</h2>
      </div>
      <div class="usa-card__body">
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use href="/themes/epa_theme/images/sprite.svg#schedule"></use>
        </svg>
      </div>
      <div class="usa-card__footer">
        <a class="usa-button" routerLink="/about-my-day" skipLocationChange>Edit My Day</a>
      </div>
    </div>
  </li>
  <li class="usa-card grid-col-6">
    <div class="usa-card__container">
      <div class="usa-card__header">
        <h2 class="usa-card__heading">About My Location</h2>
      </div>
      <div class="usa-card__body">
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use href="/themes/epa_theme/images/sprite.svg#location_on"></use>
        </svg>
      </div>
      <div class="usa-card__footer">
        <a class="usa-button" routerLink="/about-my-location" skipLocationChange>Edit My Location</a>
      </div>
    </div>
  </li>
</ul>

<div style="text-align: center">
  <a class="usa-button usa-button--big usa-button--accent-warm" routerLink="/exposure" skipLocationChange>Estimate My Exposure</a>
</div>
